import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { HomeSection } from './home';
import homeImg from '../../assets/home-bg.gif';
import CountUp from 'react-countup';

const Home2 = () => {
  return (
    <HomeSection
      id={'home'}
      className="home-sec d-flex align-items-center"
      style={{
        background: `url(${homeImg}) top center repeat`,
        height: 'calc(80vh - 180px)',
        backgroundSize: 1000,
        backgroundAttachment: 'fixed',
      }}
    >
      <Container>
        <Row className="text-center">
          <Col xs={12} sm={6} md={4} lg={3} className="mb-4">
            <h1 style={{ color: 'white', fontWeight: 'bold' }}>
              <CountUp end={6000} duration={2} />+
            </h1>
            <p style={{ color: 'white' }}>Projects Delivered</p>
          </Col>
          <Col xs={12} sm={6} md={4} lg={3} className="mb-4">
            <h1 style={{ color: 'white', fontWeight: 'bold' }}>
              <CountUp end={2} duration={5} />+
            </h1>
            <p style={{ color: 'white' }}>Valuable Partnerships</p>
          </Col>
          <Col xs={12} sm={6} md={4} lg={3} className="mb-4">
            <h1 style={{ color: 'white', fontWeight: 'bold' }}>
              <CountUp end={15} duration={5} />+
            </h1>
            <p style={{ color: 'white' }}>Countries Served</p>
          </Col>
          <Col xs={12} sm={6} md={4} lg={3} className="mb-4">
            <h1 style={{ color: 'white', fontWeight: 'bold' }}>
              <CountUp end={10} duration={5} />+
            </h1>
            <p style={{ color: 'white' }}>Tech Expert</p>
          </Col>
        </Row>
      </Container>
    </HomeSection>
  );
};

export default Home2;
